import { createContext, useState } from "react";

const AuthContext = createContext({});

// Restoring auth from sessionStorage used to happen only in an effect in
// App.js, which runs after this provider's first render -- any component
// that fires its own auth-dependent fetch on mount (before that effect
// commits) would send a request with no access token. Hydrate synchronously
// here instead, so a page refresh never renders with an empty auth object.
const readStoredAuth = () => {
  try {
    const stored = sessionStorage.getItem("loginUser");
    if (!stored) return {};

    const loginUser = JSON.parse(stored);
    return {
      role: loginUser.role,
      accessToken: loginUser.accessToken,
      clientId: loginUser.clientId,
      user: loginUser.user,
      pages: loginUser.pages,
    };
  } catch (error) {
    console.error("Failed to parse loginUser:", error);
    return {};
  }
};

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(readStoredAuth);
  const [formNavigation, setFormNavigation] = useState(false);

  let value = {
    auth,
    setAuth,
    formNavigation,
    setFormNavigation,
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContext;
